<script setup lang="tsx">
import { ref } from 'vue'
import type { PageRequest } from '@/models/api-generated'
import http from '@/services/http'
import columnStore from '@/stores/column'
import saveAs from 'file-saver'
import IconButton from '@/components/shared/IconButton.vue'
import methodEditor from '@/stores/method-editor'
import jiraCb from '@/stores/jira-checkboxes'
import type { MethodFilter } from '@/models/filters-generated'
import { showAssociatedFilter } from './shared'
import { isEmpty } from 'lodash'

const editor = methodEditor()
const jira = jiraCb()

const isDisabled = ref(false)

async function exportFile(saveAsExcel: boolean) {
	document.body.click()
	const root = columnStore().defineComponent('methods')
	const assetRoot = columnStore().defineComponent('method_assets')
	const dataAssetRoot = columnStore().defineComponent('method_data_assets')
	const moduleRoot = columnStore().defineComponent('method_modules')
	const userRoot = columnStore().defineComponent('method_users')

	const request: PageRequest<MethodFilter> = {
		page: 0,
		limit: 0,
		filter: root.filterValue() as MethodFilter,
	}

	if (showAssociatedFilter.value.asset) {
		const assetFilter = assetRoot.filterValue()
		if (!isEmpty(assetFilter)) request.filter.asset = assetFilter
	}
	if (showAssociatedFilter.value.dataAsset) {
		const dataAssetFilter = dataAssetRoot.filterValue()
		if (!isEmpty(dataAssetFilter)) request.filter.dataAsset = dataAssetFilter
	}
	if (showAssociatedFilter.value.module) {
		const moduleFilter = moduleRoot.filterValue()
		if (!isEmpty(moduleFilter)) request.filter.module = moduleFilter
	}
	if (showAssociatedFilter.value.user) {
		const userFilter = userRoot.filterValue()
		if (!isEmpty(userFilter)) request.filter.user = userFilter
	}

	isDisabled.value = true
	const { status, data } = await http.post<Blob>(`/api/method/export?saveAsExcel=${saveAsExcel}`, request, {
		responseType: 'blob',
	})
	isDisabled.value = false

	if (status === 200 && data.size > 0) {
		saveAs(data, saveAsExcel ? 'export.xlsx' : 'export.csv')
	}
}
</script>

<template>
	<div v-if="!editor.isEditMode && !jira.isJiraMode" class="dropdown">
		<IconButton
			id="exportDropdown"
			class="bi bi-file-earmark-arrow-down"
			:title="$t('misc.export')"
			:disabled="isDisabled"
			data-bs-toggle="dropdown"
		/>

		<ul class="dropdown-menu" aria-labelledby="exportDropdown">
			<li>
				<a class="dropdown-item" href="#" @click.prevent="exportFile(false)">{{ $t('exportCsv') }}</a>
			</li>
			<li>
				<a class="dropdown-item" href="#" @click.prevent="exportFile(true)">{{ $t('exportExcel') }}</a>
			</li>
		</ul>
	</div>
</template>
